import axios from 'axios';
import Api from '@/services/endpoint/tenant.service'
import config from '@/configure/index'
import { authRead } from '@/store/auth.js';
let apiBaseUrl = config.apiBaseUrl;
let token = authRead();
axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;


/** GET */
export const fetchShipment = (queryString) => {
    const resp = Api.PaymentMethod.getShipment(queryString);
    return resp.data;
};

export const fetchShipmentItems = (SHIPMENT_ID) => {
    return `${apiBaseUrl}/service/shipment/${SHIPMENT_ID}/getshipmentitem`;

};

export const fetchCarrieProvider = async(GROUP_ID) => {
    let query_string = '?v=1';
    if (GROUP_ID) {
        query_string += '&integration_group_id=' + GROUP_ID;
    }
    const resp = await Api.Integration.getIntegrationView(query_string);
    return resp.data;
};

export const getPayment = async() => {
    try {
        const resp = await Api.Shipment.getPaymentMethod();
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getStatusList = async(SHIPMENT_ID) => {
    try {
        const resp = await Api.Shipment.getStatusList(SHIPMENT_ID);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getLogs = async(SHIPMENT_ID) => {
    try {
        const resp = await Api.Shipment.getActivityLogs(SHIPMENT_ID);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getLogsShipment = async(SHIPMENT_ID) => {
    try {
        const resp = await Api.Shipment.getActivityLogsShipment(SHIPMENT_ID);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

// export const getPickupList = async(params) => {
//     try {
//         const data = Object.keys(params).map((key) => `${key}=${encodeURIComponent(params[key])}`).join('&');
//         const resp = await Api.Shipment.getPickupList('?' + data);
//         return resp.data;
//     } catch (err) {
//         console.error(err);
//         let data = {
//             'status': false,
//             'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
//         }
//         return data;
//     }
// };

export const getPickupList = async(params) => {
    try {
        const data = Object.keys(params).map((key) => `${key}=${encodeURIComponent(params[key])}`).join('&');
        const resp = await Api.PickUp.getPickUpList('?' + data);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};


export const cancelPickup = async(DATA) => {
    try {
        const resp = await Api.Shipment.postCancelPickup(DATA);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};
export const getIntegrations = async(ID) => {
    try {
        const resp = await Api.Integration.getIntegrationView('?integration_group_id=' + ID);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getCarrierCode = async(CARRIER_ID) => {
    try {
        const resp = await Api.Shipment.getCarrierCode('?carrier=' + CARRIER_ID);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};


export const getLocationByIntegrationtype = async(ID) => {
    try {
        const resp = await Api.Shipment.getLocationpickup(ID);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getIntegrationTypeById = async(ID) => {
    try {
        const resp = await Api.IntegrationType.getIntegrationTypeById(ID);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const verifyaddress = async(params) => {
    try {
        const data = Object.keys(params).map((key) => `${key}=${encodeURIComponent(params[key])}`).join('&');
        const resp = await Api.Shipment.getVerifyAddress('?' + data);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getOrder = async(ID) => {
    try {
        const resp = await Api.Order.getOrderByID(ID);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getShippingAddress = async(ID) => {
    try {
        const resp = await Api.Order.getShippingAddress(ID);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getOrderPayment = async(ORDER_ID) => {
    try {
        const resp = await Api.Order.getPaymentOrderById(ORDER_ID);
        return resp.data.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getBankAccount = async(ID) => {
    try {
        const resp = await Api.BankAccount.getBankAccountById(ID);
        return resp.data.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getOrderItem = async(ORDER_ID) => {
    try {
        const resp = await Api.Order.getOrderItem(ORDER_ID);
        return resp.data.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getProductMedia = async(PRODUCT_ID) => {
    try {
        const resp = await Api.Product.getMedia(PRODUCT_ID);
        return resp.data.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getMedia = async(ID) => {
    try {
        const resp = await Api.Media.getMediaById(ID);
        return resp.data.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getServiceShipment = async(QUERYSTRING) => {
    try {
        const resp = await Api.Shipment.getShipment(QUERYSTRING);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};


export const getShipment = async(SHIPMENT_ID) => {
    try {
        const resp = await Api.Shipment.getShipmentById(SHIPMENT_ID);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getShipmentItem = async(SHIPMENT_ID) => {
    try {
        const resp = await Api.Shipment.getShipmentItem(SHIPMENT_ID);
        return resp.data;
    } catch (err) {
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const createTracking = async(SHIPMENT_ID, DATA) => {
    try {
        const resp = await Api.Shipment.postRequestTracking(SHIPMENT_ID, DATA);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const undo = async(DATA) => {
    try {
        const resp = await Api.Shipment.postShipmentUndo(DATA);
        return resp.data;
    } catch (err) {
        let data = {
            'status': false,
            'message': err.response? err.response.data.message: err,
        }
        console.error(err);
        return data;
    }
};

export const toshipped = async(DATA) => {
    try {
        const resp = await Api.Shipment.postShipmentToShipped(DATA);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const toreadytoship = async(DATA) => {
    try {
        const resp = await Api.Shipment.postShipmentReadyToShip(DATA);

        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'message': err.response? err.response.data.message: err,
        }
        return data;
    }
};

export const updateshippingaddress = async(DATA) => {
    try {
        const resp = await Api.Shipment.updateShipmentDestination(DATA);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const updatebillingaddress = async(ORDER_ID, DATA) => {
    try {
        const resp = await Api.Order.putUpdateBillingAddress(ORDER_ID, DATA);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const sendSmsTracking = async(DATA) => {
    try {
        const resp = await Api.Shipment.postSmsTracking(DATA);
        return resp.data;
    } catch (err) {
        let error = new Error("System error");
        if (err.response) {
            error.status = err.response.data.status;
            error.statusText = err.response.data.message? err.response.data.message: err.response.statusText;
            error.message = err.response.data.message;
        }
        throw error;
    }
};

export const pickup = async(DATA) => {
    try {
        const resp = await Api.Shipment.postPickup(DATA);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const printLabel = async(DATA) => {
    try {
        const resp = await Api.ShippingLabel.postPrintLabel(DATA);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getTrackingShortenUrl = async(trackingCode) => {
    try {
        const resp = await Api.Order.getTrackingShortenUrl('?trackingCode=' + trackingCode);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const getPickupDetail = async(id) => {
    try {
        // const resp = await Api.PickUp.getPickUpList('?' + data);
        const resp = await Api.PickUp.getDetailPickUp(id);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};

export const putDeletePickup = async(ID, DATA) => {
    try {
        const resp = await Api.PickUp.postDeletePickup(ID, DATA);
        return resp.data;
    } catch (err) {
        console.error(err);
        let data = {
            'status': false,
            'statusText': err.response.data.message? err.response.data.message: err.response.statusText,
        }
        return data;
    }
};



// WEBPACK FOOTER //
// ./src/components/tenancy/admin/shipment/api/axios.js